var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-2 add-to-cart-block" },
    [
      _c("router-link", {
        staticClass: "brand-name",
        attrs: { to: _vm.product.brandUrl },
        domProps: { textContent: _vm._s(_vm.product.brandName) }
      }),
      _vm._v(" "),
      _c("h1", {
        staticClass: "product-name",
        domProps: { textContent: _vm._s(_vm.product.name) }
      }),
      _vm._v(" "),
      _vm.product.isDiscounted
        ? _c("div", { staticClass: "discounted-price my-2" }, [
            _vm._v("\n    " + _vm._s(_vm.product.oldPrice) + "\n    "),
            _vm.product.oldPriceSecondaryFormatted !== null
              ? _c("span", { staticClass: "ml-1" }, [
                  _vm._v(
                    "\n      (" +
                      _vm._s(_vm.product.oldPriceSecondaryFormatted) +
                      ")\n    "
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.product.loginPriceFormatted !== null
        ? _c(
            "div",
            [
              _c("div", { staticClass: "login-price" }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("term_torzsar_login")) + ":\n    "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "price my-2 login-price" },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.product.loginPriceFormatted) +
                      "\n      "
                  ),
                  _vm.product.loginPriceSecondaryFormatted !== null
                    ? _c("span", { staticClass: "ml-1" }, [
                        _vm._v(
                          "\n        (" +
                            _vm._s(_vm.product.loginPriceSecondaryFormatted) +
                            ")\n      "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("b-icon-info-circle-fill", {
                    staticClass: "info-icon cursor-pointer",
                    on: { click: _vm.showInfoModal }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.product.loginUnitPriceFormatted !== null &&
              _vm.product.loginUnitPriceFormatted !== false
                ? _c(
                    "div",
                    { staticClass: "unit-price my-2 login-price" },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.product.loginUnitPriceFormatted) +
                          "\n      "
                      ),
                      _vm.product.loginUnitPriceSecondaryFormatted !== null
                        ? [
                            _vm._v(
                              "\n        (" +
                                _vm._s(
                                  _vm.product.loginUnitPriceSecondaryFormatted
                                ) +
                                ")\n      "
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.product.discountPercent > 1
                ? _c("div", { staticClass: "discount-value-container mb-2" }, [
                    _c("span", { staticClass: "font-weight-bold" }, [
                      _vm._v(_vm._s(_vm.$t("term_megtakaritas")) + ":")
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.product.discountValueFormatted) +
                          "\n        "
                      ),
                      _vm.product.discountValueInSecondaryFormatted !== null
                        ? _c("span", { staticClass: "ml-1" }, [
                            _vm._v(
                              "\n          (" +
                                _vm._s(
                                  _vm.product.discountValueInSecondaryFormatted
                                ) +
                                ")\n        "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "discount-percent-badge" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.product.discountPercent) +
                          "%\n      "
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("router-link", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "term_login_or_register_for_price",
                    expression: "'term_login_or_register_for_price'"
                  }
                ],
                attrs: { to: "/login" }
              })
            ],
            1
          )
        : _vm.product.discountPercent > 1
        ? _c("div", { staticClass: "discount-value-container mb-2" }, [
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(_vm.$t("term_megtakaritas")) + ":")
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.product.discountValueFormatted) +
                  "\n      "
              ),
              _vm.product.discountValueInSecondaryFormatted !== null
                ? _c("span", { staticClass: "ml-1" }, [
                    _vm._v(
                      "\n        (" +
                        _vm._s(_vm.product.discountValueInSecondaryFormatted) +
                        ")\n      "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "discount-percent-badge" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.product.discountPercent) + "%\n    "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticClass: "price my-2",
        class: {
          discounted: _vm.product.isDiscounted,
          "discounted-price": _vm.product.loginPriceFormatted !== null
        },
        domProps: { textContent: _vm._s(_vm.currentPriceFormatted) }
      }),
      _vm._v(" "),
      _vm.product.hasSpecialShippingFlag
        ? _c("div", { staticClass: "spec-shipping-price my-2" }, [
            _c("div", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "term_specialis_szallitasi_ar",
                  expression: "'term_specialis_szallitasi_ar'"
                }
              ],
              staticClass: "label"
            }),
            _vm._v(" "),
            _c("div", { staticClass: "price" }, [
              _vm._v(
                "\n      +" +
                  _vm._s(_vm.product.specialShippingPriceFormatted) +
                  "\n    "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.product.unitPriceFormatted !== null
        ? _c(
            "div",
            { staticClass: "unit-price my-2" },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.product.unitPriceFormatted) + "\n    "
              ),
              _vm.product.unitPriceSecondaryFormatted !== null
                ? [
                    _vm._v(
                      "\n      (" +
                        _vm._s(_vm.product.unitPriceSecondaryFormatted) +
                        ")\n    "
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.product.point > 0
        ? _c("div", { staticClass: "my-2 product-point" }, [
            _vm._v(
              "\n    +" +
                _vm._s(_vm.product.point) +
                " " +
                _vm._s(_vm.$t("term_pont")) +
                "\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.product.isItemPackage
        ? _c(
            "div",
            [
              _vm._l(_vm.product.packageComponentProductList, function(
                productPackage,
                index
              ) {
                return _c("product-package", {
                  key: productPackage.id + "_" + index,
                  staticClass: "my-2",
                  attrs: {
                    "unique-id": productPackage.id + "_" + index,
                    "product-package": productPackage
                  },
                  on: { updateProductPackageItem: _vm.updateProductPackageItem }
                })
              }),
              _vm._v(" "),
              _c("quantity-input", {
                staticClass: "mb-3",
                attrs: { quantity: _vm.quantity },
                on: {
                  quantityIncreased: _vm.quantityIncreased,
                  quantityDecreased: _vm.quantityDecreased
                }
              })
            ],
            2
          )
        : _vm.product.isOrderable
        ? _c(
            "div",
            [
              _vm.product.stockInfo !== null
                ? _c("div", {
                    staticClass: "my-2",
                    class: _vm.product.stockInfo.inStock
                      ? "text-success"
                      : "text-danger",
                    domProps: { innerHTML: _vm._s(_vm.product.stockInfo.msg) }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.dosenPriceList.length > 0
                ? _c("custom-select", {
                    attrs: {
                      "select-options": _vm.dosenPriceList,
                      value: _vm.selectedQuantityOption,
                      "title-name": _vm.$t("tucat_ar")
                    },
                    on: { input: _vm.quantitySelected }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.product.paramVariantList !== null
                ? _c("product-param-variant-selects", {
                    attrs: {
                      "param-variant-list": _vm.product.paramVariantList,
                      "default-color": _vm.selectedColor,
                      "default-flavor": _vm.selectedFlavor,
                      "default-size": _vm.selectedSize
                    },
                    on: {
                      flavorSelected: _vm.flavorSelected,
                      sizeSelected: _vm.sizeSelected,
                      colorSelected: _vm.colorSelected,
                      isValidChanged: _vm.isValidChanged
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("quantity-input", {
                staticClass: "mb-3",
                attrs: { quantity: _vm.quantity },
                on: {
                  quantityIncreased: _vm.quantityIncreased,
                  quantityDecreased: _vm.quantityDecreased
                }
              }),
              _vm._v(" "),
              _vm.product.hasAssemblyFlag
                ? _c("div", [
                    _c(
                      "div",
                      { staticClass: "custom-control custom-checkbox ml-4" },
                      [
                        _c("input", {
                          staticClass: "custom-control-input",
                          attrs: { type: "checkbox", id: "assembly-checkbox" },
                          domProps: { value: _vm.isAssemblyChecked },
                          on: {
                            input: function($event) {
                              return _vm.$emit(
                                "assemblyChanged",
                                !_vm.isAssemblyChecked
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "custom-control-label assembly-label",
                            attrs: { for: "assembly-checkbox" }
                          },
                          [
                            _c("div", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "term_osszeszerles_kerem",
                                  expression: "'term_osszeszerles_kerem'"
                                }
                              ]
                            }),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "\n            (+" +
                                  _vm._s(_vm.product.assemblyPriceFormatted) +
                                  ")\n          "
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isCartBtnDisabled
                ? _c("div", {
                    staticClass: "text-danger my-2",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("nincs_ilyen_valaszthato_parameter")
                      )
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.product.giftProductList.length > 0
        ? _c(
            "div",
            _vm._l(_vm.product.giftProductList, function(giftProduct, index) {
              return _c("gift-product", {
                key: giftProduct.id + "_" + index,
                staticClass: "my-2",
                attrs: { "gift-product": giftProduct },
                on: { updateGiftProduct: _vm.updateGiftProduct }
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isCatalogPage
        ? _c("button", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "term_megrendelem",
                expression: "'term_megrendelem'"
              }
            ],
            staticClass: "custom-button w-100",
            attrs: {
              disabled:
                !_vm.product.isOrderable ||
                _vm.isCartBtnDisabled ||
                _vm.isProductAddToCartInProgress,
              "data-cy": "add-to-cart-button"
            },
            on: { click: _vm.addToCart }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoggedIn
        ? _c("button", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "general_favorite",
                expression: "'general_favorite'"
              }
            ],
            staticClass: "custom-button w-100 unfilled mt-3 product-favorite",
            class: {
              favorite: _vm.isFavoriteItem
            },
            attrs: { disabled: _vm.isFavoriteToggleInProgress },
            on: { click: _vm.toggleFavorite }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.product.isAdsFreeProduct &&
      _vm.product.otherPackagingItemList.length > 0
        ? _c("div", [
            _c("div", { staticClass: "mt-3" }, [
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "termek_mas_kiszerelesei",
                    expression: "'termek_mas_kiszerelesei'"
                  }
                ],
                staticClass: "other-packaging"
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "other-packaging-container position-relative" },
              [
                _vm._l(_vm.otherPackageList, function(
                  otherPackageProduct,
                  index
                ) {
                  return _c("product-card", {
                    key: otherPackageProduct.id + "_" + index,
                    staticClass: "my-2",
                    class: {
                      "overlay position-relative pr-1 pb-1":
                        _vm.product.otherPackagingItemList.length > 3 &&
                        _vm.otherPackageProductCountToShow === 3 &&
                        index === 2
                    },
                    attrs: {
                      product: otherPackageProduct,
                      "is-cart-item": false,
                      "is-product-add-to-cart-in-progress":
                        _vm.isProductAddToCartInProgress
                    },
                    on: {
                      addToCart: function($event) {
                        return _vm.$emit(
                          "productCardAddToCart",
                          otherPackageProduct
                        )
                      }
                    }
                  })
                }),
                _vm._v(" "),
                _vm.product.otherPackagingItemList.length > 3 &&
                _vm.otherPackageProductCountToShow === 3
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "show-all-other-packaging-product w-100 d-flex justify-content-center position-absolute"
                      },
                      [
                        _c("button", {
                          staticClass: "custom-button unfilled",
                          attrs: { "aria-label": "Több termék betöltése" },
                          on: {
                            click: function($event) {
                              _vm.otherPackageProductCountToShow =
                                _vm.product.otherPackagingItemList.length
                            }
                          }
                        })
                      ]
                    )
                  : _vm._e()
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isInfoModalOpen
        ? _c("info-modal", { on: { close: _vm.closeInfoModal } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }